import React, { useCallback } from 'react';
import AnimatedBackground from './components/AnimatedBackground';
import ContactSection from './components/ContactSection';
import HeroSection from './components/HeroSection';
import ProjectsSection from './components/ProjectsSection';
import SiteFooter from './components/SiteFooter';
import SkillsSection from './components/SkillsSection';
import { categories, projects, skills, socialLinks } from './data/portfolioData';

export default function App() {
  const handleScrollToProjects = useCallback(() => {
    const element = document.getElementById('projects');

    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return (
    <div className="min-h-screen bg-black text-white overflow-hidden relative">
      <AnimatedBackground />

      <div className="relative z-10 container mx-auto px-6 py-12 max-w-6xl">
        <HeroSection socialLinks={socialLinks} onScrollToProjects={handleScrollToProjects} />
        <SkillsSection skills={skills} categories={categories} />
        <ProjectsSection projects={projects} />
        <ContactSection />
        <SiteFooter year={2025} name="Горшков Виктор" />
      </div>
    </div>
  );
}
